import React from 'react';

const BarGraph = () => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="white">
        <title>bar-graph</title>
        <path d="M17 1h-2c-0.552 0-1 0.447-1 1v16.992h4v-16.992c0-0.553-0.447-1-1-1zM11 7h-2c-0.552 0-1 0.447-1 1v10.992h4v-10.992c0-0.553-0.447-1-1-1zM5 13h-2c-0.552 0-1 0.447-1 1v4.992h4v-4.992c0-0.553-0.447-1-1-1z"></path>
    </svg>
);

export default BarGraph;